const INFO = {
	main: {
		title: "Web Developer",
		name: "Akash Parmar",
		email: "akashparmar1520@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/akashhuyaar",
		github: "https://github.com/akash1520",
		linkedin: "https://linkedin.com/akashmparmar",
		instagram: "https://instagram.com/akashhuyaar",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-stack web developer, and an amateur mobile app developer.",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Akash Parmar. I'm a web developer with a crazy for content creation.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Bi-Direct",
			description:
				"Bi-Direct is a middleware that power bi-directional integration between two separate systems supporting REST, SOAP, or GraphQL communication with compatibility between them.",
			logo: "https://3192668336-files.gitbook.io/~/files/v0/b/gitbook-x-prod.appspot.com/o/spaces%2FzIoTx0hXAzQGNZUrY5Uv%2Fuploads%2F8dVqi4lu7Lq0YjZ4gncc%2FUntitled%20(1080%20%C3%97%201080%20px).png?alt=media&token=0fe4d81d-826d-400c-b0af-e5daeb045db7",
			linkText: "View Project",
			link: "https://devfolio.co/projects/bidirect-f15f",
		},

		{
			title: "Parivartan",
			description:
				"We are India's own NFT marketplace aiming to revamp the art industry in India.",
			logo: "https://parivartan-nfts.web.app/static/media/PARIVARTRAN.bf58f4eac164bac921b9.png",
			linkText: "View Project",
			link: "https://parivartan-nfts.web.app/",
		},

		{
			title: "TidyTweet",
			description:
				"TidyTweet is a Google Chrome extension that helps users easily and quickly clean up their Twitter feeds. With TidyTweet, users can filter out unwanted content and unimportant information, so they can focus on the tweets that matter most.",
			logo: "https://six-paperback-08b.notion.site/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F688d16a8-8cf9-4eae-81e9-c12e249d8d15%2FDALLE_2023-04-25_14.16.55.png?table=block&id=5f3c672a-0873-4de2-b995-459969a2079b&spaceId=d9557181-bfd0-4e09-b655-1742d4f376c6&width=250&userId=&cache=v2",
			linkText: "View Project",
			link: "https://six-paperback-08b.notion.site/TidyTweet-5f3c672a08734de2b995459969a2079b",
		},
	],
};

export default INFO;
